(() => {
  function parseMoneyToMinor(text) {
    if (!text) return null;
    try {
      const numeric = String(text)
        .replace(/[^0-9.,]/g, '')
        .replace(/,/g, '');
      const pounds = parseFloat(numeric);
      if (Number.isFinite(pounds)) return Math.round(pounds * 100);
    } catch {}
    return null;
  }

  function getCurrentPriceMinor(product) {
    if (!product) return null;
    let priceEl = product.querySelector(
      '.product-info__price .price .price__current.tpo_product_price'
    );
    if (!priceEl)
      priceEl = product.querySelector('.product-info__price .price .price__current .js-value');
    if (!priceEl) priceEl = product.querySelector('.product-info__price .price .price__current');
    if (!priceEl) return null;
    return parseMoneyToMinor(priceEl.textContent || '');
  }

  function getCurrentPriceText(product) {
    if (!product) return '';
    let priceEl = product.querySelector(
      '.product-info__price .price .price__current.tpo_product_price'
    );
    if (!priceEl)
      priceEl = product.querySelector('.product-info__price .price .price__current .js-value');
    if (!priceEl) priceEl = product.querySelector('.product-info__price .price .price__current');
    return priceEl && priceEl.textContent ? priceEl.textContent.trim() : '';
  }

  function refreshKlarna(product, amountMinor) {
    if (!product) return;
    product.querySelectorAll('klarna-placement').forEach((el) => {
      el.setAttribute('data-purchase-amount', String(amountMinor));
    });
    try {
      if (
        window.Klarna &&
        window.Klarna.OnSiteMessaging &&
        typeof window.Klarna.OnSiteMessaging.refresh === 'function'
      ) {
        window.Klarna.OnSiteMessaging.refresh();
      }
    } catch {}
  }

  function refreshSquare(product, amountMinor) {
    if (!product) return;
    const amountMajor = Math.round(Number(amountMinor || 0) / 100);
    product.querySelectorAll('square-placement').forEach((el) => {
      el.setAttribute('data-amount', String(amountMajor));
      try {
        el.dispatchEvent(new CustomEvent('on:os-message:update', { bubbles: true }));
      } catch {}
    });
    // Best-effort globals (no-ops if absent)
    try {
      if (window.AfterPay && typeof window.AfterPay.refresh === 'function')
        window.AfterPay.refresh();
      if (window.Afterpay && typeof window.Afterpay.refresh === 'function')
        window.Afterpay.refresh();
    } catch {}
  }

  function dispatchUnifiedPriceEvent(product, amountMinor) {
    try {
      product.dispatchEvent(
        new CustomEvent('on:product-price:change', {
          bubbles: true,
          detail: { amountMinor, amount: amountMinor },
        })
      );
    } catch {}
  }

  function refreshShopPay(product, amountMinor) {
    if (!product) return;
    const priceText = getCurrentPriceText(product);
    product.querySelectorAll('.js-instalments-form shopify-payment-terms').forEach((el) => {
      try {
        const metaStr = el.getAttribute('shopify-meta');
        if (!metaStr) return;
        const meta = JSON.parse(metaStr);
        const form = el.closest('form');
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        const variantId = variantInput ? variantInput.value : null;

        if (Array.isArray(meta.variants) && meta.variants.length > 0) {
          // Update full_price string to the current displayed price string
          meta.variants[0].full_price = priceText || meta.variants[0].full_price;
        }

        if (variantId) {
          el.setAttribute('variant-id', String(variantId));
        }

        // Setting the attribute triggers the widget to refresh itself
        el.setAttribute('shopify-meta', JSON.stringify(meta));
      } catch {
        // no-op
      }
    });
  }

  function refreshPayPal(product, amountMinor) {
    if (!product) return;
    const amountMajorDecimal = (Number(amountMinor || 0) / 100).toFixed(2);
    product.querySelectorAll('[data-pp-message]').forEach((el) => {
      el.setAttribute('data-pp-amount', String(amountMajorDecimal));
      try {
        if (window.paypal && typeof window.paypal.Messages === 'function') {
          window.paypal.Messages({ amount: amountMajorDecimal }).render(el);
        } else {
          el.dispatchEvent(new CustomEvent('on:pp-message:update', { bubbles: true }));
        }
      } catch {}
    });
  }

  function debounce(fn, wait = 200) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  }

  function initForProduct(product) {
    const runUpdate = () => {
      const amountMinor = getCurrentPriceMinor(product);
      if (typeof amountMinor === 'number') {
        refreshKlarna(product, amountMinor);
        refreshSquare(product, amountMinor);
        refreshPayPal(product, amountMinor);
        refreshShopPay(product, amountMinor);
        dispatchUnifiedPriceEvent(product, amountMinor);
      }
    };

    const debouncedUpdate = debounce(runUpdate, 150);

    // Initial sync
    runUpdate();

    // Watch Easify/UI price changes
    const priceRoot = product.querySelector('.product-info__price');
    if (priceRoot && 'MutationObserver' in window) {
      const mo = new MutationObserver(() => debouncedUpdate());
      mo.observe(priceRoot, { childList: true, characterData: true, subtree: true });
    }

    // Also listen variant change to be safe
    const variantPicker = product.querySelector('variant-picker');
    if (variantPicker) {
      variantPicker.addEventListener('on:variant:change', debouncedUpdate);
    }
  }

  function init() {
    document.querySelectorAll('.product').forEach((product) => {
      if (window.initLazyScript) {
        window.initLazyScript(product, () => initForProduct(product));
      } else {
        initForProduct(product);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('on:bfcache:load-restore', init, { once: true });
})();
